import { render, staticRenderFns } from "./MagazzinoArticoliStoricoContabileComponent.vue?vue&type=template&id=78e88fb9&scoped=true"
import script from "./MagazzinoArticoliStoricoContabileComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliStoricoContabileComponent.vue?vue&type=script&lang=js"
import style0 from "./MagazzinoArticoliStoricoContabileComponent.vue?vue&type=style&index=0&id=78e88fb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e88fb9",
  null
  
)

export default component.exports